import { IntlFormatters, MessageDescriptor } from 'react-intl';

export const safeFormatMessage = (
  formatMessage: IntlFormatters['formatMessage'],
  messageDescriptor: MessageDescriptor,
  values: any = {},
  // @ts-expect-error
): string => (messageDescriptor.id ? formatMessage(messageDescriptor, values) : messageDescriptor.defaultMessage);
